import React, { useEffect, useRef, useState } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Field, FormSection, change } from 'redux-form';
import { connect } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CreateIcon from '@material-ui/icons/Create';
import Tooltip from '@material-ui/core/Tooltip';
import MobileAppHomeImage from '../../../shared/img/mock-app-home.svg';
import MobileAppDetailImage from '../../../shared/img/mock-app-detail.svg';
import HexColorPicker from '../../../shared/components/HexColorPicker';
import ImageCrop from '../../../shared/components/form/ImageCrop';
import Accordion from '../../../shared/components/Accordion';

const Customization = ({
  t,
  dispatch,
  school,
  handleSaveLogo,
  getReportPreview,
}) => {
  const imageCropRef = useRef(null);
  const [variables, setVariables] = useState({
    primaryColor: '#000',
    secondaryColor: '#000',
    headerColor: '#000',
    fillColor: '#000',
    headerContentColor: '#000',
  });
  const [loadedImages, setLoadedImages] = useState({
    first: false,
    second: false,
  });
  const [logo, setLogo] = useState('');

  const getPathsIcons = (contentDocument) => {
    return Array.from(contentDocument.getElementsByClassName('ma-icon'));
  };

  // eslint-disable-next-line no-unused-vars
  const getPathsLogo = (contentDocument) => {
    return Array.from(contentDocument.getElementsByClassName('svg_logo'));
  };

  const getPathsBgHeader = (contentDocument) => {
    return Array.from(contentDocument.getElementsByClassName('ma-bg-header'));
  };

  const getPathsColorHeader = (contentDocument) => {
    return Array.from(
      contentDocument.getElementsByClassName('ma-color-header')
    );
  };

  const getPathsPrimaryColor = (contentDocument) => {
    return Array.from(
      contentDocument.getElementsByClassName('ma-primary-color')
    );
  };

  const updateFillIcons = (pathsIcons) => {
    pathsIcons.forEach((path) => {
      const reassign = path;
      reassign.style.fill = variables.fillColor;
    });
  };

  // eslint-disable-next-line no-unused-vars
  const updateLogo = (pathsLogo) => {
    pathsLogo.forEach((path) => {
      const reassign = path;
      if (logo) {
        reassign.setAttribute('href', logo);
      }
    });
  };

  const updateFillBgHeader = (pathsIcons) => {
    pathsIcons.forEach((path) => {
      const reassign = path;
      reassign.style.fill = variables.headerColor;
    });
  };

  const updateFillColorHeader = (pathsIcons) => {
    pathsIcons.forEach((path) => {
      const reassign = path;
      reassign.style.fill = variables.headerContentColor;
    });
  };
  const updateFillPrimaryColor = (pathsIcons) => {
    pathsIcons.forEach((path) => {
      const reassign = path;
      reassign.style.fill = variables.primaryColor;
    });
  };

  const getSVGs = () => {
    return Array.from(document.getElementsByClassName('ma-svg'));
  };

  const updateSVGs = () => {
    const svgs = getSVGs();
    svgs.forEach((svg) => {
      const { contentDocument } = svg;
      // updateLogo(getPathsLogo(contentDocument));
      updateFillIcons(getPathsIcons(contentDocument));
      updateFillBgHeader(getPathsBgHeader(contentDocument));
      updateFillColorHeader(getPathsColorHeader(contentDocument));
      updateFillPrimaryColor(getPathsPrimaryColor(contentDocument));
    });
  };

  const changeReduxFormValue = (field, color) => {
    dispatch(
      change('DataSchoolForm', `customizationVariables.${field}`, color)
    );
  };

  const onChangeValuesForm = (field, color) => {
    changeReduxFormValue(field, color);
    const updatedVariables = { ...variables };
    updatedVariables[field] = color;
    setVariables(updatedVariables);
  };

  const changeLoadedImage = (field) => {
    const updatedLoadedImages = { ...loadedImages };
    updatedLoadedImages[field] = true;
    setLoadedImages(updatedLoadedImages);
  };

  const openFileBrowser = () => {
    imageCropRef.current.openFileBrowser();
  };

  const removeLogo = () => {
    setLogo(undefined);
    const schoolWithoutFile = { ...school };
    schoolWithoutFile.logoUrl = null;
    handleSaveLogo(schoolWithoutFile);
  };

  const onAcceptedFile = (file) => {
    const schoolWithFile = { ...school };
    schoolWithFile.file = file;
    handleSaveLogo(schoolWithFile);
    setLogo(file.preview);
  };

  useEffect(() => {
    if (loadedImages.first && loadedImages.second) {
      updateSVGs();
    }
  }, [variables, logo]);

  useEffect(() => {
    setVariables(school.customizationVariables);
    setLogo(school.logoUrl);
  }, [school]);

  useEffect(() => {
    if (loadedImages.first && loadedImages.second) {
      updateSVGs();
    }
  }, [loadedImages]);

  return (
    <div className="custom-mobile-app">
      <Accordion title={t('general.logo')}>
        <ImageCrop ref={imageCropRef} t={t} onAcceptedFile={onAcceptedFile} />
        <div className="d-flex flex-column justify-content-center">
          <div className="d-flex justify-content-center mb-1">
            <Tooltip title={t('general.edit')} arrow>
              <IconButton aria-label="replace" onClick={openFileBrowser}>
                <CreateIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title={t('general.remove')} arrow>
              <IconButton aria-label="remove" onClick={removeLogo}>
                <CloseIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title={t('general.view')} arrow>
              <IconButton aria-label="view" onClick={getReportPreview}>
                <VisibilityIcon />
              </IconButton>
            </Tooltip>
          </div>
          {logo ? (
            <img src={logo} alt="Logo" className="border border-light" />
          ) : (
            <div className="h6 d-flex justify-content-center">
              {t('general.no-logo')}
            </div>
          )}
        </div>
      </Accordion>
      <Accordion title={t('general.app')}>
        <div className="svg-group">
          <object
            onLoad={() => changeLoadedImage('first')}
            className="ma-svg mb-3"
            data={MobileAppHomeImage}
            aria-label=""
          />
          <object
            onLoad={() => changeLoadedImage('second')}
            className="ma-svg"
            data={MobileAppDetailImage}
            aria-label=""
          />
        </div>
        <FormSection
          name="customizationVariables"
          className="d-flex justify-content-around"
        >
          <div className="form__form-group d-flex flex-column align-items-center">
            <span className="form__form-group-label">
              {t('general.icon-color')}
            </span>
            <div className="form_form-group-field modal-field pr-3">
              <Field
                name="fillColor"
                component={HexColorPicker}
                colorSelected={variables.fillColor}
                onHandleChange={(color) =>
                  onChangeValuesForm('fillColor', color)
                }
              />
            </div>
          </div>
          <div className="form__form-group d-flex flex-column align-items-center">
            <span className="form__form-group-label">
              {t('general.header-background-color')}
            </span>
            <div className="form_form-group-field modal-field pr-3">
              <Field
                name="headerColor"
                component={HexColorPicker}
                colorSelected={variables.headerColor}
                onHandleChange={(color) =>
                  onChangeValuesForm('headerColor', color)
                }
              />
            </div>
          </div>
          <div className="form__form-group d-flex flex-column align-items-center">
            <span className="form__form-group-label">
              {t('general.header-content-color')}
            </span>
            <div className="form_form-group-field modal-field pr-3">
              <Field
                name="headerContentColor"
                component={HexColorPicker}
                colorSelected={variables.headerContentColor}
                onHandleChange={(color) =>
                  onChangeValuesForm('headerContentColor', color)
                }
              />
            </div>
          </div>
          <div className="form__form-group d-flex flex-column align-items-center">
            <span className="form__form-group-label">
              {t('general.primary-color')}
            </span>
            <div className="form_form-group-field modal-field pr-3">
              <Field
                name="primaryColor"
                component={HexColorPicker}
                colorSelected={variables.primaryColor}
                onHandleChange={(color) =>
                  onChangeValuesForm('primaryColor', color)
                }
              />
            </div>
          </div>
        </FormSection>
      </Accordion>
    </div>
  );
};

Customization.propTypes = {
  t: PropTypes.func.isRequired,
  handleSaveLogo: PropTypes.func.isRequired,
  getReportPreview: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  school: PropTypes.shape({
    customizationVariables: PropTypes.shape({
      primaryColor: PropTypes.string,
      headerColor: PropTypes.string,
      fillColor: PropTypes.string,
      headerContentColor: PropTypes.string,
    }).isRequired,
    appType: PropTypes.string,
    logoUrl: PropTypes.string,
    fantasyName: PropTypes.string,
  }).isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(Customization)
);
